import axios from 'axios'
import { CalculateRequest } from '@/dto/calculate/CalculateRequest'
import CalculatedDelivery from '@/dto/calculate/CalculatedDelivery'

const DeliveryCalculatorService = {
  calculateDelivery(request: CalculateRequest): Promise<CalculatedDelivery[]> {
    return axios
      .post('/v1/calculate', request)
      .then(
        response =>
          Object.values(response.data.deliveries || {}).filter(
            delivery => delivery
          ) as CalculatedDelivery[]
      )
  },

  calculateDeliveryPoints(
    request: CalculateRequest
  ): Promise<CalculatedDelivery[]> {
    return axios
      .post('/v1/calculate-delivery-points', request)
      .then(
        response =>
          Object.values(response.data.deliveries || {}).filter(
            delivery => delivery
          ) as CalculatedDelivery[]
      )
  },
}

export default DeliveryCalculatorService
